(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snc-selected-sale"] && !Shopify.designMode) return;
  try {
    (function(){
  var end = Date.parse('2026-10-04T23:59:00+02:00');
  function expire(){
    if(end>Date.now()) return;
    document.querySelectorAll('[data-snc-sale-active]').forEach(function(el){el.hidden=true;});
    document.querySelectorAll('[data-snc-sale-ended]').forEach(function(el){el.hidden=false;});
  }
  function init(){
    function addMobileSale(){var menu=document.querySelector("#nav-drawer-section .mobile-nav"),template=document.querySelector("[data-snc-sale-mobile-template]");
    if(menu&&template&&!menu.querySelector(".snc-sale-mobile-nav")){var entry=template.content.firstElementChild;if(entry){var nodes=menu.querySelectorAll(":scope > li");if(nodes.length>1)nodes[1].after(entry.cloneNode(true));else menu.append(entry.cloneNode(true));}return true;}return !!(menu&&menu.querySelector(".snc-sale-mobile-nav"));}
    if(!addMobileSale()){var menuObserver=new MutationObserver(function(){if(addMobileSale())menuObserver.disconnect();});menuObserver.observe(document.documentElement,{childList:true,subtree:true});}
    expire();
    if(end>Date.now()) setTimeout(expire,Math.min(end-Date.now()+50,2147483647));
    var reminder=document.querySelector('[data-snc-sale-return]');
    var dismissed=false;
    try{dismissed=sessionStorage.getItem('snc-selected-sale-dismissed')==='yes';}catch(error){}
    function updateReminder(){if(reminder) reminder.hidden=dismissed||Date.now()>=end||window.scrollY<=1400;}
    window.addEventListener('scroll',updateReminder,{passive:true});updateReminder();
    document.addEventListener('click',function(event){
      var dismiss=event.target.closest('[data-snc-sale-dismiss]');
      if(dismiss){dismissed=true;try{sessionStorage.setItem('snc-selected-sale-dismissed','yes');}catch(error){}updateReminder();}
      var button=event.target.closest('[data-snc-sale-copy]');
      if(!button)return;
      var status=button.querySelector('[role="status"]');
      if(!navigator.clipboard){status.textContent=button.dataset.fallback;return;}
      navigator.clipboard.writeText('SNC15').then(function(){status.textContent=button.dataset.copied;},function(){status.textContent=button.dataset.fallback;});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
  } catch(e) { console.error(e); }
})();

})();
